import React from 'react';
import './Teaser.scss';
import { SYSTEM_DEVICE, useSystemDevice } from '../../hooks/useSystemDevice';
import Button from '../Button/Button';

export interface Props {
  buttonText: string;
  className?: string;
  footnote?: string;
  imageSrc: string;
  reverseDesktop?: boolean;
  text?: string;
  title?: string;
  url: string;
}

const Teaser: React.FC<Props> = (props) => {
  const scope = 'Teaser';

  const systemDevice = useSystemDevice();
  const className = [
    scope,
    `${scope}--${systemDevice}`,
    props.footnote && `${scope}--withFootnote`,
    props.className,
  ]
    .filter((className) => className)
    .join(' ');

  const clickButton = () => {
    window.open(props.url);
  };

  const textBlock = (
    <div className={`${scope}-textBlock`}>
      {props.title && <div className={`${scope}-title`}>{props.title}</div>}
      {props.text && <div className={`${scope}-text`}>{props.text}</div>}
      <div className={`${scope}-buttonContainer`}>
        <Button
          className={`${scope}-button`}
          onClick={clickButton}
          text={props.buttonText}
        />
      </div>
      {props.footnote && (
        <div className={`${scope}-footnote`}>{props.footnote}</div>
      )}
    </div>
  );
  const imageBlock = (
    <div className={`${scope}-imageBlock`}>
      <img alt="" src={props.imageSrc} className={`${scope}-image`} />
    </div>
  );

  return (
    <section className={className}>
      {systemDevice === SYSTEM_DEVICE.DESKTOP && !props.reverseDesktop ? (
        <>
          {textBlock}
          {imageBlock}
        </>
      ) : (
        <>
          {imageBlock}
          {textBlock}
        </>
      )}
    </section>
  );
};

export default Teaser;
